<template>
    <main>
        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="fa fa-file-text"></i> Treinamentos</b></h2>
                </div>
            </div>
            <div class="col-sm-6" v-if="!hasDisabled && escolaId==276 && !ehDetalhe">
                <button class="btn btn-success uppercase pull-right" @click="openCreate()">
                    Adicionar
                </button>
            </div>

            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <!--<th>#</th>
                                <th>#</th>-->
                                <th>Instituição</th>
                                <th>Curso</th>
                                <th>Situação do Treinamento</th>
                                <th>Data Conclusão</th>

                                <th class="text-center" width="150"  v-if="!hasDisabled && escolaId==276 && !ehDetalhe"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <!--<td>{{ item.colaboradorTreinamentoId }}</td>
                                <td>{{ item.colaboradorId }}</td>-->
                                <td>{{ item.nmInstituicao }}</td>
                                <td>{{ item.nmCurso }}</td>
                                <td>{{ item.situacaoTreinamentoDescricao }}</td>
                                <td>{{ item.dtConclusao }}</td>

                                <td class="text-center" v-if="!hasDisabled  && escolaId==276 && !ehDetalhe">
                                    <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ colaboradorTreinamentoId: item.colaboradorTreinamentoId })">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ colaboradorTreinamentoId: item.colaboradorTreinamentoId })">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :colaborador-id="colaboradorId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="colaboradorTreinamentoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'colaboradortreinamento',
        mixins: [base],
        components: { formCreate, formEdit },
        props: { colaboradorId: Number, escolaId: Number, hasDisabled: Boolean, ehDetalhe: Boolean },
        data() {
            return {

                resources: {
                    filter: 'colaboradortreinamento',
                    remove: 'colaboradortreinamento'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.colaboradorTreinamentoId = model.colaboradorTreinamentoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.colaboradorId = this.colaboradorId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>